import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import { CreateUserType, NewUserFormInput } from '@xemplo/gp-types';
import { useModalDialog } from '@xemplo/modal-dialog';
import { safeCallAsync } from '@xemplo/safe-call';
import { ToastType, useToast } from '@xemplo/toast';
import { useCreateUser } from '@xemplo/users-query';

import { CreateCompanyUserProps } from '../create-company-user.types';

import { sanitisePayload } from './create-company-user-form.helper';

export function useCreateCompanyUserForm({
  companyId,
  onSuccess,
}: CreateCompanyUserProps) {
  const { addToast } = useToast();
  const { mutateAsync: createUser } = useCreateUser(CreateUserType.CompanyUser);
  const modal = useModalDialog({ id: 'create-company-user-modal' });

  const form = useForm<NewUserFormInput>({
    defaultValues: {
      getNotifications: 'true',
      userPersona: [{ companyId }],
    },
  });

  const handleCancel = useCallback(() => {
    form.reset();
    modal.closeDialog();
  }, [form, modal]);

  const handleSubmit = form.handleSubmit(async (data: NewUserFormInput) => {
    const [, error] = await safeCallAsync(createUser(sanitisePayload(data)));
    if (error) return;
    form.reset();
    modal.closeDialog();
    addToast({ text: 'User created successfully', type: ToastType.Confirmation });
    onSuccess?.();
  });

  return { form, modal, handleCancel, handleSubmit };
}
